<template>
  <!-- 商品分组 -->
  <div class="salesmanUser">
    <!-- 面包屑导航 -->
    <page-bar
      @back="goBack"
      @refresh="handleRefresh"
      :title="$route.meta.title"
    >
      <template slot="controls">
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="getUserList('')"
          >绑定业务员</el-button
        >
        <el-button
          type="danger"
          icon="el-icon-delete"
          :disabled="selectedList.length == 0"
          @click="handleDel('')"
          >批量解绑</el-button
        >
      </template>
    </page-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <el-input
          v-model="searchForm.name"
          style="width: 200px; margin-right: 5px"
          clearable
          placeholder="输入编号/名称"
          @keyup.enter.native="getTableData(1)"
        ></el-input>
        <el-button type="primary" icon="el-icon-search" @click="getTableData(1)"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      :row-style="{ color: '#303133' }"
      tooltip-effect="dark"
      @selection-change="selectionChange"
      style="width: 100%"
    >
      <el-table-column type="selection" align="center" width="55">
      </el-table-column>
      <el-table-column label="序号" align="center" width="50">
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="UserName"
        label="用户名"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="Name"
        label="真实姓名"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="TelPhone"
        label="手机号"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <!-- <el-table-column
        prop="businessname"
        label="所属厂家"
        align="center"
        show-overflow-tooltip
      ></el-table-column> -->
      <el-table-column label="操作" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="danger"
            style="padding: 2px 3px"
            plain
            @click="handleDel(scope.row.UserId)"
            >解绑
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>

    <!-- 数据选择 -->
    <!--装车单列表-->
    <el-dialog
      title="业务员选择"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="80%"
    >
      <search-bar>
        <template>
          <el-input
            style="width: 200px; margin-right: 5px"
            clearable
            placeholder="输入编号/名称"
            v-model="searchUser"
          >
          </el-input>
          <el-button type="primary" icon="el-icon-search" @click="search"
            >搜索</el-button
          >
          <el-button type="primary" icon="el-icon-circle-check" @click="submit"
            >确定
          </el-button>
        </template>
      </search-bar>
      <el-table
        stripe
        height="500px"
        width="100%"
        border
        :data="tableList"
        @selection-change="rowClick"
        row-key="code"
        ref="selectiontt"
        element-loading-text="拼命加载中..."
        v-loading="loading"
      >
        <el-table-column
          width="50"
          type="selection"
          align="center"
          :reserve-selection="true"
        ></el-table-column>
        <el-table-column type="index" label="序号" align="center">
          <template slot-scope="scope">
            <span>{{
              (currentchange_vlue - 1) * pagesize_value + scope.$index + 1
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="UserName"
          label="用户名"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="Name"
          label="真实姓名"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="TelPhone"
          label="手机号"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <!-- <el-table-column
          prop="businessname"
          label="所属厂家"
          align="center"
          show-overflow-tooltip
        ></el-table-column> -->
      </el-table>
      <el-pagination
        :current-page="currentchange_vlue"
        :page-size="pagesize_value"
        layout="total,prev, pager, next, jumper,sizes"
        :total="totalnumber"
        prev-text="上一页"
        next-text="下一页"
        :page-sizes="pagesize"
        @size-change="getsizechange"
        @current-change="getcurrentchange"
      ></el-pagination>
    </el-dialog>
  </div>
</template>

<script>
//表单验证
// import { mustFill } from "@/mixins/data/valid.js";

export default {
  name: "bindingSalesman",
  data() {
    return {
      id: "",
      /**表格数据 */
      // {
      //   id: "商品编号",
      //   goodsId: "商品ID",
      //   name:"商品名称",
      //   factory:"生产厂家",
      //   spec:"规格",
      //   unit:"单位",
      //   time:"加入时间",
      // }
      tableData: [],
      searchForm: {
        name: "",
      },
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      selectedList: [],
      // 数据选择
      dialogVisible: false,
      loading: false, //加载
      searchUser: "", //弹窗
      tableList: [], //列表数据
      //表格下面分页
      userIds: "", //勾选的业务员
      currentPage: 1,
      totalnumber: 0, //总条数
      pagesize_value: 25, //默认设置页数量
      currentchange_vlue: 1, //总页码
      pagesize: [25, 50, 100, 200],
    };
  },
  mounted() {
    if (this.$route.query.prams) {
      let prams = JSON.parse(decodeURIComponent(this.$route.query.prams));
      if (prams) {
        this.id = prams;
        this.getTableData();
      }
    }
  },
  methods: {
    updata() {
      if (this.id) {
        this.getTableData();
      }
    },
    goBack() {
      this.$router.go(-1);
      this.$destroy();
    },
    /**获取表格 */
    getTableData(num) {
      this.currPage = num == 1 ? 1 : this.currPage;
      let data = {
        // entId: window.localStorage.getItem("entId"),
        code: this.id,
        valType: "T02",
        valStr: this.searchForm.name,
        pageIndex: this.currPage,
        pageSize: this.pageSize,
      };
      this.$request({
        url: "/Management/SalesManAdmin/GetGroupSalesMan",
        method: "post",
        data: data,
      })
        .then((res) => {
          this.tableData = [];
          this.allPage = res.tatal;
          if (res.success) {
            this.tableData = res.dataList;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
    /**selection change触发事件 */
    selectionChange(section) {
      //存放选中的表格数据
      this.selectedList = section;
    },
    //弹窗
    getUserList() {
      this.dialogVisible = true;
      this.searchUser = "";
      this.userIds = "";
      this.search();
    },
    // 查询未绑定的客户
    search() {
      this.currentchange_vlue = 1;
      this.getUserLists();
    },
    // 获取弹出框表格数据
    getUserLists() {
      this.loading = true;
      let data = {
        // entId: window.localStorage.getItem("entId"),
        code: "",
        valType: "T01",
        PageIndex: this.currentchange_vlue,
        PageSize: this.pagesize_value,
        valStr: this.searchUser,
      };
      this.$request({
        method: "post",
        url: "/Management/SalesManAdmin/GetGroupSalesMan",
        data: data,
      })
        .then((res) => {
          this.loading = false;
          if (res.success) {
            this.tableList = res.dataList;
            this.totalnumber = res.recordCount;
            this.$refs.selectiontt.clearSelection();
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
            this.totalnumber = 0;
            this.$refs.selectiontt.clearSelection();
          }
        })
        .catch((err) => {
          this.loading = false;
          window.console.log(err);
          this.totalnumber = 0;
        });
    },
    //页数选择
    getsizechange(val) {
      let _this = this;
      this.currentchange_vlue = 1;
      _this.pagesize_value = val;
      this.getUserLists();
    },
    //选择分页页数
    getcurrentchange(val) {
      let _this = this;
      _this.currentchange_vlue = val;
      this.getUserLists();
    },
    // 选择单条数据
    rowClick(section) {
      this.userIds = "";
      for (var i = 0; i < section.length; i++) {
        this.userIds += section[i].UserId + ",";
      }
    },

    /**点击删除商品 */
    handleDel(id) {
      this.$confirm("确定解绑吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      })
        .then(() => {
          id = id || this.selectedList.map((item) => item.UserId).join(",");
          let data = {
            list: id,
            code: "",
            entId: window.localStorage.getItem("entId"),
          };
          this.$request({
            url: "GradeTree/UsersBindingOperation",
            method: "post",
            data: data,
          })
            .then((res) => {
              if (res.success) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.getTableData();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch(() => {});
    },
    /**提交绑定*/
    submit() {
      if (this.userIds == "") {
        this.$message({
          message: "请先勾选需要绑定的业务员！",
          type: "warning",
        });
        return;
      }
      let data = {
        entId: window.localStorage.getItem("entId"),
        code: this.id,
        list: this.userIds,
      };
      this.$request({
        method: "post",
        url: "GradeTree/UsersBindingOperation",
        data: data,
      })
        .then((res) => {
          if (res.success) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.$refs.selectiontt.clearSelection();
            this.getTableData();
            this.dialogVisible = false;
          } else {
            this.$refs.selectiontt.clearSelection();
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
  },
};
</script>

<style scoped>
.salesmanUser {
  width: 100%;
  height: 100%;
}
</style>
